<template>
    <div class="findCar-page">
      <div class="form">
        <div class="fm-row"><div class="field">姓   名</div><div class="value"><input v-model="formData.username" placeholder="请输入您的姓名" placeholderClass="fdc-ph"/></div></div>
        <div class="fm-row"><div class="field">电   话</div><div class="value"><input v-model="formData.mobile" placeholder="请输入您的电话" placeholderClass="fdc-ph" /></div></div>
        <div class="fm-row"><div class="field">意向品牌</div><div class="value" @click="openBrand = true"><input v-model="formData.manufactor" placeholder="请选择您的意向品牌" placeholderClass="fdc-ph" /></div></div>
        <div class="fm-row"><div class="field">意向车型</div><div class="value"><input v-model="formData.model" placeholder="请输入的意向车型" placeholderClass="fdc-ph" /></div></div>
        <div class="fm-row"><div class="field">获取位置</div><div class="value"><input v-model="formData.location" placeholder="请输入您的地理位置" placeholderClass="fdc-ph" /></div></div>
        <div class="btn-row">
          <button v-if="processing" class="btn-find">提交中...</button>
          <button v-else class="btn-find" @click="onFindCar">立即找车</button>
        </div>
      </div>
      <div class="rec-con">
        <div class="title">推荐车型</div>
        <div class="list-con">
          <com-rec-car-list hiddenFilter/>
        </div>
      </div>
      <brands-select :openBrandBox="openBrand" v-on:onClosed="openBrand = false" v-on:onSelected="onConfirmBrand"/>
    </div>
</template>

<script>
import { mapState } from "vuex"
import { Toast, MessageBox } from 'mint-ui'
import { createClue } from '../api'
import brandsSelect from '../components/widget/brandsSelect'
import ComRecCarList from '../components/list/comRecCarList'

export default {
  components: {
    brandsSelect,
    ComRecCarList
  },
  props: {},
  data() {
    return {
      formData: {
        username: "",//客户姓名
        mobile: "",//客户电话
        manufactor: "",//厂家（品牌）
        model: "",//型号（车型）
        refereeopenid: "",
        extinfo: {
          location: ""
        }
      },
      openBrand: false,//打开品牌选择器
      processing: false//提交处理中
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "userInfo"
    ])
  },
  methods: {
    onConfirmBrand(item){
      this.formData.manufactor = item.name
      this.openBrand = false
    },
    async onFindCar(){
      const {formData} = this
      if(formData.username.length === 0){
        Toast({
          message: '姓名还未填写！',
          position: 'middle',
          duration: 1500
        });
        return ;
      }
      if(!/^1\d{10}$/ig.test(formData.mobile)){
        Toast({
          message: '请正确填写手机码！',
          position: 'middle',
          duration: 1500
        });
        return ;
      }
      const {user : {appid, openid}} = this.userInfo
      const {username, mobile, manufactor, model, extinfo }  = formData
      this.processing = true
      const ret = await createClue({appid, atype: 3, username, mobile, manufactor, model, refereeopenid: openid, extinfo: JSON.stringify(extinfo) })
      this.processing = false
      if(ret.data){
        this.formData = {username: "", mobile: "", manufactor: "", model: "", extinfo: {location: ""} }
        MessageBox('提交成功', '我们将努力为您找到心怡车辆！');
      }else{
        MessageBox('提交失败', '可能网络原因，请稍后再试！');
      }
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {
    if(window.wx){
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          console.log('location:',res)
          const latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          const longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          const speed = res.speed; // 速度，以米/每秒计
          const accuracy = res.accuracy; // 位置精度
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.findCar-page{
    width: 100%;
    overflow: hidden;
    .form{
        margin:0.30407459963511047rem;
        background:#fff;
        padding: 0.30407459963511047rem 0px 0.10135819987837016rem 0px;
        border-radius: 5px;
        input::placeholder{
            background: #F5F8FA;
            color:#ccc;
            font-size: .26rem;
        }
        .fm-row{
            height: 0.8108655990269613rem;
            display: flex;
            border-radius: 40px;
            background: #F5F8FA;
            margin: 0.2533954996959254rem;
            align-items: center;
            font-size: 0.2635313196837624rem;
            .field{
                width: 1.824447597810663rem;
                text-indent: 0.5067909993918508rem;
                color:#555;
                border-right: solid 1px #999;
            }
            .value{
                flex: 1;
                padding-left: 0.2533954996959254rem;
                input{
                  background:#F5F8FA;
                }
            }
        }
        .btn-row{
            padding: 0.5067909993918508rem 0px 0.30407459963511047rem 0px;
            display: flex;
            justify-content: center;
            .btn-find{
                width: 3.4867220758159334rem;
                height: 0.8108655990269613rem;
                background: linear-gradient(135deg, #18B7F9, #0C85FF);
                box-shadow: 0px 0.14190147982971824rem 0.2533954996959254rem 0px rgba(24, 183, 249, 0.2);
                border-radius: 40px;
                color:#fff;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.2635313196837624rem;
            }
        }
    }
    .rec-con{
        box-sizing: border-box;
        margin: 0.30407459963511047rem 0.30407459963511047rem 0px 0.30407459963511047rem;
        background: #FFFFFF;
        box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
        border-radius: 5px;
        .title{
            font-size: 0.3243462396107845rem;
            color:#313131;
            padding: 0.3rem .3rem;
        }
        .list-con{
            width: 100%;
        }
    }
    .fdc-ph{
        font-size: 0.2635313196837624rem;
        color:#aaa;
    }
}
</style>